import { Link } from "react-router-dom";
import moment from "moment";

var CurrentUser = require("lib/account/CurrentUser");
var DataRouting = require("lib/routing/DataRouting");
var DataAnswers = require("components/data/subjects/DataAnswers");
var DataGoals = require("components/data/subjects/DataGoals");
var DataQuizzes = require("components/data/subjects/DataQuizzes");
var DataLogTables = require("components/data/subjects/DataLogTables");
var DataTextTables = require("components/data/subjects/DataTextTables");
var DataReadingLevelGraphs = require("components/data/subjects/DataReadingLevelGraphs");
var Spinner = require("components/utility/Spinner");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var DataSelectors = require("lib/selectors/DataSelectors");
var Glyphicon = require("components/utility/icons/Glyphicon");
var RosterRouting = require("lib/routing/RosterRouting");
var Features = require("lib/account/Features");
var EvaluationOverride = require("components/writing/evaluations/EvaluationOverride");


import { connect } from "react-redux";

require("data/teacher_digest_container");
// large request should have a smaller loading requirement to prevent large loading
// times with an empty screen
function isLoading(state, userIDs) {
	if (userIDs && $wr.isLargeRequest(userIDs)) {
		return DataSelectors.isLoadingDigests({ state, key: 'index', userIDs })
	} else {
		return  ReadingSelectors.isLoadingBooks({ state, key: 'index', userIDs: userIDs }) ||
		        ReadingSelectors.isLoadingLogs({ state, key: 'index', userIDs: userIDs }) ||
			DataSelectors.isLoadingDigests({ state, key: 'index', userIDs: userIDs }) ||
			ReadingSelectors.isLoadingReadingLevels({ state, key: 'index', userIDs: userIDs })
	}
}


@connect(
	(state, props) => ({
		user: CurrentUser.get(),
		userIsSchoolAdmin: CurrentUser.isSchoolAdmin(),
		userIsTeacherAdmin: CurrentUser.isTeacherAdmin(),

		expectationsDateSpans: (CurrentUser.get() || {}).expectations_date_spans,
		schoolYearStartDate: moment(CurrentUser.fetchSchoolYearDates().startDate).format("YYYY-MM-DD"),
		schoolYearEndDate: moment().format("YYYY-MM-DD"),

		isLoading: isLoading(state, props.userIDs || _.pluck(RosterSelectors.students({ state }), "id"),),
		userIDs: _.pluck(RosterSelectors.students({ state }), "id"),
		hasLogReading: Features.isEnabled(Features.LOG_READING),
		nonDemoStudents: _.select(RosterSelectors.students({ state, conditions: {} }), function(student) {
			return !student.demo_for_teacher
		}),
	}),
	() => ({})
)

class TeacherDigestContainer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	dataLinkWithExpectationDates(subject) {
		return DataRouting.getPath({
			subjectType: subject,
			startDate: this.props.expectationsDateSpans[0].start,
			endDate: this.props.expectationsDateSpans[0].end,
		})
	}

	dataLinkWithSchoolYearDates(subject) {

		return DataRouting.getPath({
			subjectType: subject,
			startDate: this.props.schoolYearStartDate,
			endDate: this.props.schoolYearEndDate,
		})
	}

	isOnboardingComplete() {
		var onboardingData = this.props.user.prefs.onboarding;
		return _.select(onboardingData, (stepData, key) => {
			return !stepData;
		}).length == 0;
	}

	addStudents() {
		$wr.redirect("/roster?addNewStudentsButton=true") 
	}
	fetchVideo() {
		var weekNumber = moment().week();
		var index = weekNumber % 8;
		if (this.props.user.account.product == "wrSolo") {
			switch(index) {
				case 0:
					var video = (<div><iframe src="//player.vimeo.com/video/445701238" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 1:
					var video = (<div><iframe src="//player.vimeo.com/video/445702087" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 2:
					var video = (<div><iframe src="//player.vimeo.com/video/446974856" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 3:
					var video = (<div><iframe src="//player.vimeo.com/video/445702959" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 4:
					var video = (<div><iframe src="//player.vimeo.com/video/447264463" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 5:
					var video = (<div><iframe src="//player.vimeo.com/video/446987031" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 6:
					var video = (<div><iframe src="//player.vimeo.com/video/446980822" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 7:
					var video = (<div><iframe src="//player.vimeo.com/video/446978356" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 8:
					var video = (<div><iframe src="//player.vimeo.com/video/446980030" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 9:
					var video = (<div><iframe src="//player.vimeo.com/video/446979749" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
			}
		} else {
			switch(index) {
				case 0:
					var video = (<div><iframe src="//player.vimeo.com/video/445701238" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 1:
					var video = (<div><iframe src="//player.vimeo.com/video/445702087" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 2:
					var video = (<div><iframe src="//player.vimeo.com/video/445702732" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 3:
					var video = (<div><iframe src="//player.vimeo.com/video/446974856" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 4:
					var video = (<div><iframe src="//player.vimeo.com/video/446982781" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 5:
					var video = (<div><iframe src="//player.vimeo.com/video/445702959" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 6: 
					var video = (<div><iframe src="//player.vimeo.com/video/447264463" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 7: 
					var video = (<div><iframe src="//player.vimeo.com/video/446980504" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 8: 
					var video = (<div><iframe src="//player.vimeo.com/video/446981204" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 9: 
					var video = (<div><iframe src="//player.vimeo.com/video/446986708" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 10:
					var video = (<div><iframe src="//player.vimeo.com/video/446987031" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 11:
					var video = (<div><iframe src="//player.vimeo.com/video/446980822" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 12:
					var video = (<div><iframe src="//player.vimeo.com/video/446978356" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 13:
					var video = (<div><iframe src="//player.vimeo.com/video/446975674" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 14:
					var video = (<div><iframe src="//player.vimeo.com/video/446989378" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 15:
					var video = (<div><iframe src="//player.vimeo.com/video/446980030" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
				case 16:
					var video = (<div><iframe src="//player.vimeo.com/video/446979749" width="435" height="337" frameBorder="0" allow="autoplay; fullscreen" webkitAllowFullScreen mozAllowFullScreen allowFullScreen></iframe></div>);
					break;
			}
		}
		return video;
	}

	render() {
		var goalsStartDate = this.props.expectationsDateSpans[0].start;
		var goalsEndDate = this.props.expectationsDateSpans[0].end;

		var yearStartDate = this.props.schoolYearStartDate;
		var yearEndDate = this.props.schoolYearEndDate;

		if (this.props.isLoading) {
			return (
				<div>
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		} else {
			if (this.props.userIDs && this.props.nonDemoStudents.length == 0) {
				if (this.isOnboardingComplete()) {
					var addStudents = (
						<div className="addStudents">
							<p>
								Add your students and their writing data and scores will appear
								here! <a onClick={ this.addStudents }>Add Students </a> 
							</p>
						</div>
					)
				}
			}

			var booksSection = (
				<div className="digestSection">
					<header>Books</header>
					<div className="digestContent">
						{/* including skipPreloadData prop sometimes results in incomplete
							loading of booktitles */}
						<DataTextTables userIDs={ this.props.userIDs } booksAmount={ 3 }
							startDate={ yearStartDate } endDate={ yearEndDate } />
					</div>
					<Link className="seeMoreLink" to={ this.dataLinkWithSchoolYearDates(DataRouting.SUBJECT_BOOKS) }>
						See More
						<Glyphicon icon="menu-right" />
					</Link>
				</div>
			)

			var diffLink =
			RosterRouting.getPath({
				activeView: RosterRouting.VIEWS.GOALS,
			}) + "?edit_expectations=true";

			var goalsSection = (
				<div className="digestSection clearfix">
					<div className="digestSection clearfix">
						<div>
							<header>Goals</header>
							<div className="goalDates">
								{ $wr.formatDate(goalsStartDate) } - { $wr.formatDate(goalsEndDate) }
							</div>
							<span className="editGoalsLink">
								<a href='https://whooosreading.zendesk.com/hc/en-us/articles/360024761351' target='_blank'>Learn How to Edit Goals</a>
							</span>
						</div>

						<div className="digestContent">
							<DataGoals startDate={ goalsStartDate } endDate={ goalsEndDate }
								userIDs={ this.props.userIDs } studentLimit={ 3 } showGoals />
						</div>
						<Link className="seeMoreLink" to={ this.dataLinkWithExpectationDates(DataRouting.SUBJECT_GOALS) }>
							See More
							<Glyphicon icon="menu-right" />
						</Link>
					</div>
				</div>
			)

			if (this.props.hasLogReading) {
				var seeMoreLink = (
					<Link className="seeMoreLink" to={ this.dataLinkWithSchoolYearDates(DataRouting.SUBJECT_LOG_LIST) }>
						See More
						<Glyphicon icon="menu-right" />
					</Link> 
				)
			}

			var upperSection = goalsSection
			var lowerSection = booksSection

			var itemTwo = (
				<div>
          <header>Tell Us How We're Scoring</header>
          <div className="disgestContent">
            <EvaluationOverride userIDs = {this.props.userIDs}/>
          </div>
        </div>
			)
			var itemFour = (
				<div>
					<header>Recent Practice Question</header>
					<div className="digestContent">
						<DataAnswers answerType={ DataAnswers.PRACTICE_QUESTIONS }
							startDate={ yearStartDate } endDate={ yearEndDate }
							userIDs={ this.props.userIDs }
							order="completed_at_desc"
							perPage={ 20 } fakePerPage={ 1 } showFullData
							sketchEmptyState />
					</div>
					<Link className="seeMoreLink" to={ this.dataLinkWithSchoolYearDates(DataRouting.SUBJECT_ANSWERS) }>
						See More
						<Glyphicon icon="menu-right" />
					</Link>
				</div>
			)

			var itemThree = (
				<div className="digestVideo">
					<header>Watch a Video</header>
					<div className="digestContent video">{ this.fetchVideo() }</div>
				</div>
			)

			var itemFive = (
				<div>
					<header>Reading Logs</header>
					<div className="digestContent">
						<DataLogTables userIDs={ this.props.userIDs } condensedLayout
							startDate={ yearStartDate } endDate={ yearEndDate } />
					</div>
					{ seeMoreLink }
				</div>
			)

			var rlGraph = (
				<div>
					<header>Reading Level Graph</header>
					<div className="digestContent">
						<DataReadingLevelGraphs userIDs={ this.props.userIDs }
							startDate={ yearStartDate } endDate={ yearEndDate }
							studentLimit={ 1 } numMonths={ 4 } />
					</div>
					<Link className="seeMoreLink" to={ this.dataLinkWithSchoolYearDates(DataRouting.SUBJECT_READING_LEVEL_GRAPH) }>
						See More
						<Glyphicon icon="menu-right" />
					</Link>
				</div>
			)
			var itemSix = (
				<div className="rlGraphContainer">
					<div className="digestSection">{ rlGraph }</div>
				</div>
			)

			return (
				<div className="teacherDigestContainer">
					{ addStudents }
					{ upperSection }
					<div className="digestMiddleContainer">
						<div className="digestSection widerDigestSection">
							{ itemTwo }
						</div>
						<div className="digestSection">
							{ itemThree }
						</div>
					</div>

					{ lowerSection }

					<div className="digestMiddleContainer">
						<div className="digestSection widerDigestSection">
							{ itemFour }
						</div>
						<div className="digestSection">
							{ itemFive }
						</div>
					</div>
					{ itemSix }
				</div>
			)
		}
	}
}

TeacherDigestContainer.WrappedComponent.propTypes = PageStrictPropTypes({

	// From @connect
	userIDs: PropTypes.array,
	user: PropTypes.object,
	userIsSchoolAdmin: PropTypes.bool,
	userIsTeacherAdmin: PropTypes.bool,
	expectationsDateSpans: PropTypes.array,
	schoolYearStartDate: PropTypes.string,
	schoolYearEndDate: PropTypes.string,

	isLoading: PropTypes.bool,
	hasLogReading: PropTypes.bool,
	nonDemoStudents: PropTypes.array
});

module.exports = TeacherDigestContainer;



// WEBPACK FOOTER //
// ./modules/components/data/TeacherDigestContainer.js